{
  "AGENT_BOTS": {
    "HEADER": "Bots",
    "LOADING_EDITOR": "Cargando el editor...",
    "DESCRIPTION": "Agent Bots are like the most fabulous members of your team. They can handle the small stuff, so you can focus on the stuff that matters. Give them a try.You can manage your bots from this page or create new ones using the 'Configure new bot' button.",
    "LEARN_MORE": "Learn about agent bots",
    "CSML_BOT_EDITOR": {
      "NAME": {
        "LABEL": "Nombre del bot",
        "PLACEHOLDER": "Nombra tu bot.",
        "ERROR": "El nombre del bot es obligatorio."
      },
      "DESCRIPTION": {
        "LABEL": "Descripción del bot",
        "PLACEHOLDER": "¿Qué hace este bot?"
      },
      "BOT_CONFIG": {
        "ERROR": "Por favor, introduzca la configuración del bot CSML arriba.",
        "API_ERROR": "La configuración CSML no es válida, por favor corríjala e inténtalo de nuevo."
      },
      "SUBMIT": "Validar y guardar"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Seleccione un bot de agente",
      "DESC": "Asigne un bot de agente a su bandeja de entrada. Pueden manejar conversaciones iniciales y transferirlas a un agente en vivo cuando sea necesario.",
      "SUBMIT": "Actualizar",
      "DISCONNECT": "Desconectar Bot",
      "SUCCESS_MESSAGE": "El bot del agente se ha actualizado con éxito.",
      "DISCONNECTED_SUCCESS_MESSAGE": "Desconectado correctamente el bot agente.",
      "ERROR_MESSAGE": "No se pudo actualizar el bot de agente, por favor inténtalo de nuevo más tarde.",
      "DISCONNECTED_ERROR_MESSAGE": "No se pudo desconectar el bot de agente, por favor inténtalo de nuevo más tarde.",
      "SELECT_PLACEHOLDER": "Seleccionar bot",
      "OPTION": "{name} ({description})",
      "COUNTRY_BOTS": {
        "TITLE": "Bots por país",
        "DESC": "Esta bandeja de entrada atiende a varios países. Una conversación va al bot de su país: según la tienda de Kaufland, el mercado del pedido de Allegro o, si no, el idioma en el que escribe el cliente. Las demás conversaciones van al bot predeterminado de arriba.",
        "COUNTRY": "Selecciona un país",
        "BOT": "Seleccionar bot",
        "ADD": "Añadir bot para un país",
        "REMOVE": "Eliminar",
        "DEFAULT_REQUIRED": "Selecciona primero un bot predeterminado. El bot de un país solo lo sustituye para ese país.",
        "DISCONNECT_ALL": "Desconectar todos los bots"
      }
    },
    "ADD": {
      "TITLE": "Configurar nuevo bot",
      "CANCEL_BUTTON_TEXT": "Cancelar",
      "API": {
        "SUCCESS_MESSAGE": "Bot añadido correctamente.",
        "ERROR_MESSAGE": "No se pudo agregar el bot, Inténtalo de nuevo más tarde."
      }
    },
    "LIST": {
      "404": "No se encontraron bots, puedes crear un bot haciendo clic en el botón 'Configurar nuevo bot' ↗",
      "LOADING": "Obteniendo bots...",
      "TYPE": "Tipo de bot",
      "TABLE_HEADER": {
        "DETAILS": "Detalles del bot",
        "URL": "URL del Webhook"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Eliminar",
      "TITLE": "Eliminar bot",
      "SUBMIT": "Eliminar",
      "CANCEL_BUTTON_TEXT": "Cancelar",
      "DESCRIPTION": "¿Estás seguro de que quieres eliminar este bot? Esta acción es irreversible.",
      "API": {
        "SUCCESS_MESSAGE": "Bot eliminado correctamente.",
        "ERROR_MESSAGE": "No se pudo eliminar el bot. Por favor, inténtalo de nuevo."
      },
      "CONFIRM": {
        "TITLE": "Confirmar eliminación",
        "MESSAGE": "¿Estás seguro de que deseas eliminar {name}?",
        "YES": "Sí, eliminar",
        "NO": "No, conservar"
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Editar",
      "LOADING": "Obteniendo bots...",
      "TITLE": "Editar bot",
      "CANCEL_BUTTON_TEXT": "Cancelar",
      "API": {
        "SUCCESS_MESSAGE": "Bot actualizado correctamente.",
        "ERROR_MESSAGE": "No se pudo actualizar el bot, por favor inténtalo de nuevo más tarde."
      }
    },
    "TYPES": {
      "WEBHOOK": "Webhook Bot",
      "CSML": "CSML Bot"
    },
    "GLOBAL_BOT": "Bot del sistema",
    "GLOBAL_BOT_BADGE": "Sistema",
    "AVATAR": {
      "SUCCESS_DELETE": "Avatar del bot eliminado correctamente",
      "ERROR_DELETE": "Error al eliminar el avatar del bot, por favor inténtalo de nuevo"
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Avatar del bot"
      },
      "NAME": {
        "LABEL": "Nombre del bot",
        "PLACEHOLDER": "Introduce el nombre del bot",
        "REQUIRED": "El nombre del bot es obligatorio"
      },
      "DESCRIPTION": {
        "LABEL": "Descripción",
        "PLACEHOLDER": "¿Qué hace este bot?"
      },
      "WEBHOOK_URL": {
        "LABEL": "URL del Webhook",
        "PLACEHOLDER": "https://example.com/webhook",
        "REQUIRED": "La URL del Webhook es obligatoria"
      },
      "ERRORS": {
        "NAME": "El nombre del bot es obligatorio",
        "URL": "La URL del Webhook es obligatoria",
        "VALID_URL": "Por favor, introduce una URL válida que comience con http:// o https://"
      },
      "CANCEL": "Cancelar",
      "CREATE": "Crear bot",
      "UPDATE": "Actualizar bot"
    },
    "WEBHOOK": {
      "DESCRIPTION": "Configura un bot de webhook para integrar con tus servicios personalizados. El bot recibirá y procesará eventos de las conversaciones y podrá responder a ellos."
    }
  }
}
